class LocalizationForm extends HTMLElement {
  onClick = (e) => {
    if (!e.target.closest("a")) return;

    this.onItemClick(e);
  };

  connectedCallback() {
    this.input = this.querySelector("[data-localization-form-input]");
    this.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.input.value = event.target.dataset.value;
    if (form) form.submit();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
